import Spinner from "components/common/Spinner";
import MessageDialog from "components/dialog/MessageDialog";
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";

const LoadingLayout: React.FC = () => {
  const [loading, setLoading] = React.useState(true);
  const [msgDialog, setMsgDialog] = React.useState<
    { title?: string; message?: string; callback?: () => void } | undefined
  >();

  const navigate = useNavigate();

  return (
    <div className="h-full mx-auto" style={{ maxWidth: "1920px" }}>
      <Outlet
        context={{
          loading: { flg: loading, setState: setLoading },
          msgDialog: { flg: msgDialog, setState: setMsgDialog },
          navigate,
        }}
      />
      {loading && (
        <div className="bg-black bg-opacity-60 fixed w-screen h-screen top-0 z-[101]">
          <div className="h-full flex justify-center items-center">
            <Spinner />
          </div>
        </div>
      )}
      {msgDialog && (
        <MessageDialog
          title={msgDialog?.title ?? ""}
          message={msgDialog?.message}
          close={() => {
            setMsgDialog(undefined);
            if (msgDialog?.callback) {
              msgDialog.callback();
            }
          }}
        />
      )}
    </div>
  );
};

export default LoadingLayout;
